export default __webpack_public_path__ + "static/media/sync.195cb26d.svg";